/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createChargePointConsumptionSourcesFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ChargePointConsumptionSources, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/consumption/sources
 */
export interface SourcesRequestBuilder extends BaseRequestBuilder<SourcesRequestBuilder> {
    /**
     * GetChargePointConsumptionSources
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ChargePointConsumptionSources>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<SourcesRequestBuilderGetQueryParameters> | undefined) : Promise<ChargePointConsumptionSources | undefined>;
    /**
     * GetChargePointConsumptionSources
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<SourcesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetChargePointConsumptionSources
 */
export interface SourcesRequestBuilderGetQueryParameters {
    year?: number;
}
/**
 * Uri template for the request builder.
 */
export const SourcesRequestBuilderUriTemplate = "{+baseurl}/chargepoints/consumption/sources{?Year*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const SourcesRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "year": "Year",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SourcesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SourcesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createChargePointConsumptionSourcesFromDiscriminatorValue,
        queryParametersMapper: SourcesRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
